import React from 'react';
import { formatDateToDay } from 'src/utils/dateUtils';
import { pluralizeNights } from 'src/utils/pluralizeUtils';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import { TEST_ID_MOBILE_SUMMARY_HOTEL_NIGHTS_HOTEL } from './constants';

type Props = {
  startDate: string;
  endDate: string;
  nights: number;
  checkInTime: string;
  checkOutTime: string;
};

const HotelNightsCount = (props: Props) => {
  const { startDate, endDate, checkInTime, checkOutTime, nights } = props;

  const { t } = useTranslation();

  return (
    <div data-testid={TEST_ID_MOBILE_SUMMARY_HOTEL_NIGHTS_HOTEL}>
      <CheckInCheckOut>
        <CheckIn>
          <Title>{t('checkout.summary.hotel.hotelCheckIn')}</Title>
          <Date>{formatDateToDay(startDate)}</Date>
          <Time>
            {t('checkout.summary.hotel.from')} {checkInTime}
          </Time>
        </CheckIn>
        <CheckOut>
          <Title>{t('checkout.summary.hotel.hotelCheckOut')}</Title>
          <Date>{formatDateToDay(endDate)}</Date>
          <Time>
            {t('checkout.summary.hotel.until')} {checkOutTime}
          </Time>
        </CheckOut>
      </CheckInCheckOut>
      <TotalNights>
        {t('checkout.summary.hotel.totalLength')}:{' '}
        <NightsCount>
          {nights} {pluralizeNights(nights)}
        </NightsCount>
      </TotalNights>
    </div>
  );
};

const CheckInCheckOut = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

const CheckIn = styled.div`
  flex: 1;
`;

const CheckOut = styled.div`
  flex: 1;
  border-color: #e6e9ee;
  border-style: solid;
  border-width: 0 0 0 1px;
  padding-left: 8px;
`;

const Title = styled.div`
  font-size: 12px;
  line-height: 16px;

  color: #4d4d4d;
`;

const Date = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
`;

const Time = styled.div`
  font-size: 12px;
  line-height: 16px;

  color: #4d4d4d;
`;

const TotalNights = styled.div`
  color: #4d4d4d;
`;

const NightsCount = styled.span`
  font-weight: 500;
  color: #17181a;
`;

export default HotelNightsCount;
